export enum Selectors {
  REMOTE_WRAPPER = '[data-animation="remote-enter-wrapper"]',
  REMOTE_TOOLTIP = '.remote-control-tooltip',
  TV_OVERLAY = '[data-animation="tv-frame-screen"]',
  OPENING_SCREEN_COPY = '.c04-opening-screen .intro-copy',
  OPENING_SCREEN_MODAL = '.c04-opening-screen',
  NAVIGATION_BUTTON = '.s01-navigation .button-menu-wrapper',
  QUESTION_MARK_BUTTON = '.c03-question-mark-modal .question-modal-toggle',
  DISCLAIMER = 'app-a03-disclaimer-paragraph',
  ENDSCREEN_WRAPPER = '.c06-end-screen',
  ENDSCREEN_TITLE = '.c06-end-screen .main-copy',
  ENDSCREEN_COPY = '.c06-end-screen .secondary-copy',
  ENDSCREEN_BUTTONS_WRAPPER = '.c06-end-screen .buttons-wrapper',
  VOICE_SEARCH_MODAL = '[data-element="voice-page-modal"]',
}
